import React, { Component } from "react";
import { TouchableOpacity, View } from "react-native";
import TextView from "./TextView";
import { componentStyles, appStyles } from "../theme/styles";
import { greenDarkColor, redColor } from "../theme/colors";
import { persianNumber, getStatusPay } from "../utils/utils";

export default class SessionItem extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        var item = this.props.data;
        var color = item.status_servant != null && item.status_servant == 'done' ? greenDarkColor : redColor;
        return (
            <View style={componentStyles.sessionItem}>
                <TouchableOpacity style={[item.status_pay == null || item.status_pay.length == 0 ?
                    { borderBottomColor: color, borderBottomWidth: 1 } : null]} onPress={() => {
                        if (item.status_pay == null || item.status_pay.length == 0) {
                            this.props.onPayment();
                        }
                    }}>
                    <TextView style={[appStyles.textCenter, { fontSize: 12, color: color }]}>{getStatusPay(item.status_pay)}</TextView>
                </TouchableOpacity>
                <TextView style={[appStyles.textCenter, { fontSize: 12, color: color }]}>{item.status_servant != null && item.status_servant == 'done' ? persianNumber(item.done_date) : (item.status_servant != null ? 'در حال انجام' : '-')}</TextView>
                <TextView style={[appStyles.textCenter, { fontSize: 12, color: color }]}>{item.servant_name != null ? item.servant_name : '-'}</TextView>
                <View style={[componentStyles.sessionIndexWraper, { backgroundColor: color }]}>
                    <TextView style={{ color: 'white' }}>{persianNumber(item.session_number)}</TextView>
                </View>
            </View>
        );
    }
}


